import React from 'react';

const EXPO_LINK =
  'exp://u.expo.dev/f228d5be-22cc-4a35-917d-7d24a2316902/group/0148e93f-2cf1-4d19-b879-dd3559b77b6f';
const EXPO_GO_IOS = 'https://apps.apple.com/app/expo-go/id982107779';
const EXPO_GO_ANDROID = 'https://play.google.com/store/apps/details?id=host.exp.exponent';

export default function AppPage() {
  return (
    <main style={styles.page} dir="rtl">
      <section style={styles.shell}>
        <div style={styles.badge}>MindClash</div>
        <h1 style={styles.title}>جرّب التطبيق على الجوال</h1>
        <p style={styles.copy}>
          هذا الرابط يعمل من خلال تطبيق Expo Go. ثبّت Expo Go أولاً، ثم افتح رابط التجربة.
        </p>

        <a href={EXPO_LINK} style={styles.primaryButton}>
          فتح تجربة التطبيق
        </a>

        <div style={styles.notice}>تحتاج إلى Expo Go لتشغيل الرابط على iOS أو Android.</div>

        <div style={styles.storeGrid}>
          <a href={EXPO_GO_IOS} style={styles.storeButton}>
            <span style={styles.storeLabel}>تحميل Expo Go</span>
            <strong style={styles.storeName}>iOS App Store</strong>
          </a>
          <a href={EXPO_GO_ANDROID} style={styles.storeButton}>
            <span style={styles.storeLabel}>تحميل Expo Go</span>
            <strong style={styles.storeName}>Android Google Play</strong>
          </a>
        </div>
      </section>
    </main>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'grid',
    placeItems: 'center',
    padding: '28px 18px',
    fontFamily: 'Tajawal, sans-serif',
    color: '#193a30',
    background:
      'radial-gradient(circle at 16% 10%, rgba(215, 173, 74, 0.18), transparent 28%), radial-gradient(circle at 86% 86%, rgba(19, 99, 76, 0.52), transparent 34%), linear-gradient(180deg, #0b3d31 0%, #0f5f48 46%, #082e27 100%)'
  },
  shell: {
    width: 'min(100%, 620px)',
    background: 'rgba(255,255,255,0.92)',
    border: '1px solid rgba(15, 95, 72, 0.16)',
    borderRadius: 8,
    boxShadow: '0 24px 80px rgba(25, 58, 48, 0.18)',
    padding: '34px 24px',
    textAlign: 'center'
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 34,
    padding: '6px 14px',
    borderRadius: 999,
    background: '#0f5f48',
    color: '#fff',
    fontWeight: 900,
    marginBottom: 18
  },
  title: {
    margin: 0,
    color: '#0f5f48',
    fontSize: 34,
    fontWeight: 900,
    lineHeight: 1.25
  },
  copy: {
    margin: '16px auto 26px',
    maxWidth: 460,
    color: '#5f635a',
    fontSize: 17,
    fontWeight: 700,
    lineHeight: 1.8
  },
  primaryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'min(100%, 360px)',
    minHeight: 54,
    padding: '14px 22px',
    borderRadius: 8,
    background: '#d7ad4a',
    color: '#193a30',
    textDecoration: 'none',
    fontSize: 18,
    fontWeight: 900,
    boxShadow: '0 12px 26px rgba(215, 173, 74, 0.32)'
  },
  notice: {
    margin: '22px auto',
    padding: '12px 14px',
    maxWidth: 420,
    borderRadius: 8,
    background: '#f7f1e3',
    color: '#6c6658',
    fontWeight: 800
  },
  storeGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
    gap: 12,
    marginTop: 18
  },
  storeButton: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    padding: '15px 16px',
    border: '1px solid rgba(15, 95, 72, 0.22)',
    borderRadius: 8,
    background: '#fff',
    color: '#193a30',
    textDecoration: 'none',
    textAlign: 'right'
  },
  storeLabel: {
    color: '#6c6658',
    fontSize: 13,
    fontWeight: 700
  },
  storeName: {
    color: '#0f5f48',
    fontSize: 17,
    fontWeight: 900
  }
};
